export function populateCodeActionBox(entry, container, timelineElement) {
    container.addClass("code_action");
    var clonedBox = $(".code_action_box_prototype").clone().appendTo(container);
    clonedBox.removeClass("code_action_box_prototype");
    clonedBox.removeClass("hidden");
    clonedBox.addClass("code_action_box");
    clonedBox.find("#timeline_input_fk_code_").attr("id", "timeline_input_fk_code_" + entry.id);
    clonedBox.find("#timeline_input_fk_code_" + entry.id).attr("name", "timeline_input_fk_code_" + entry.id);
    clonedBox.find(".headline").prepend(entry.description);
    clonedBox.find(".expiry_date").text(dbDateToString(entry.code_expiry_date, false));
    clonedBox.find(".author_comment").html(entry.content);
    clonedBox.find(".spinner").hide();
    if (timelineElement !== undefined) {
        addImpression(timelineElement.id);
    }
}
